import { useSelector } from 'react-redux'

const FooterExtended = ({ dispatch, ...props }) => {
  let language = props.language || {}

  const {
    user: { first_name, last_name },
  } = useSelector((store) => store.auth)

  return (
    <div className='container-fluid'>
      <div className='row checklist-footer-row'>
        <div className='col-12'>
          <button
            onClick={() => dispatch(props.approveChecklist())}
            className='btn btn-default btn-info second-approval-btn'
          >
            {language.manager_report
              ? language.manager_report.approve_as
              : null}{' '}
            {`${first_name} ${last_name}`}
          </button>

          <p className='second-approval-message'>
            {props.assessor.access === 1
              ? `${
                  language.manager_report
                    ? language.manager_report.approve_checklist_confirm
                    : null
                } ${props.managerName}`
              : 'Confirm checklist'}
          </p>
        </div>
      </div>
    </div>
  )
}

export default FooterExtended
